import styled from "styled-components";
import { themeGet } from "@styled-system/theme-get";
import Inputs from "../../components/Input/Input";
import walletIcon from '../../assets/icons/wallet.svg';
import couponIcon from '../../assets/icons/coupon.svg';
import paymentIcon from "../../assets/icons/choose-payment.svg";
import couponExpressIcon from "../../assets/icons/coupon-express.svg"
import walletExpressIcon from '../../assets/icons/wallet-express.svg';
import paymentExpressIcon from "../../assets/icons/choose-payment-express.svg";
import css from "@styled-system/css";
import { right, style, variant, width } from "styled-system";

const CheckoutWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  padding: 130px 60px 60px;
  position: relative;

  @media (max-width: 1100px) {
    padding-left: 0;
    padding-right: 0;
  }

  @media (max-width: 990px) {
    padding-top: 60px;
  }
`;

export const CheckoutContainer = styled.div`
  width: 100%;
  display: flex;
  direction: ltr;
  counter-reset: section-counter;

  @media (min-width: 990px) {
    width: 90%;
      max-width: 1300px;
    margin-left: auto;
    margin-right: auto;
  }

  @media (max-width: 767px) {
    flex-direction: column;
  }
`;

export const CheckoutInformation = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  display: flex;
  direction: ltr;
  flex-direction: column;
  // margin-right: 20px;
  padding: 20px;

  @media (max-width: 990px) {
    margin-right: 0px;
  }

  @media (max-width: 425px) {
    padding: 0;
  }
`;

export const Heading = styled.h3`
  font-family: "Lato", sans-serif;
  font-size: 21px;
  font-weight: ${themeGet("fontWeights.3", "400")};
  color: ${themeGet("colors.darkBold", "#0D1136")};
  line-height: 1.4;
  margin-bottom: 10px;
  position: relative;
  // width: calc(100% - 100px);
    display: -webkit-flex;
  display: flex;
    -webkit-align-items: center;
  align-items: center;

  &.mb-0 { margin-bottom: 0; }

  @media (max-width: 600px) {
    font-size: 19px;
  }
`;

export const SubHeading = styled.h3`
  font-family: "Lato", sans-serif;
  font-size: 18px;
  font-weight: ${themeGet("fontWeights.3", "400")};
  color: ${themeGet("colors.darkBold", "#0D1136")};
  line-height: 1.4;
  margin-bottom: 20px;
  // position: relative;
  // width: calc(100% - 100px);
  // display: flex;
  // align-items: center;

  @media (max-width: 600px) {
    font-size: 16px;
  }
`;

export const InformationBox = styled.div`
  background-color: #ffffff;
  padding: 30px 20px 20px 20px;
  // padding-bottom: 20px;
  position: relative;
  margin-bottom: 20px;
  box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.08);

  @media (min-width: 768px) and (max-width: 1024px) {
    &.address .radioGroup label{
      max-width: 100% !important;
      width: 100% !important;
    }
  }

   
  
  .btn-success.express:not(:disabled):not(.disabled).active,
  .btn-success.express:not(:disabled):not(.disabled):active,
  .btn-success.express:focus,
  .btn-success.express {
      background-color: #f01266 !important;
      color: #FFFFFF !important;
      border-color: transparent !important;
    box-shadow: none;
  }
  
  .btn-group-vertical {
    width: 100%;
  }
  .custom-control-input:checked~.custom-control-label::before {
    border-color: #999;
    background-color: #999;
  }
  
  .coupon-pay-wrapper {
    width: 100%;
    
    .coupon-icon-wrapper {
      position: relative;
        display: -webkit-flex;
      display: flex;
      gap: 10px;
      background-color: #fff;
      padding: 10px 0;
      top: 25px;
      left: 0px;
      font-size: 18px;
        -webkit-align-items: center;
      align-items: center;
      width: 100%;
      max-width: 300px;
      color: #9cc54b;

        &.normal {
            color: #9cc54b !important;
        }

        &.express {
            color: #f01266 !important;
        }
      &:before {
        content: '';
        display: block;
        background-image: url(${couponIcon});
        width: 32px;
        height: 32px;
      }

        &.express:before {
            background-image: url(${couponExpressIcon}) !important;
        }
    }
    .coupon-pay-btn {
      background-color: transparent;
      color: #000;
      border: 1px solid #e7e7e7;
      display: flex;
      flex-direction: column;
      align-items: center;
      line-height: 1.2em;
      padding: 30px 0px;
      
      .coupon-pay-btn-content{
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: normal;
        width: 100%;
      }
      
      &.btn-success:focus-visible,
      &.btn-success:active,
      &.btn-success:focus,
      &.btn-success { box-shadow: none; background-color: transparent; color: #000; border: 1px solid #e7e7e7; }
      
      .btn-title {
        flex: 2;
        text-align: left;
        
        .btn-sub-title {
          display: block;
          color: #999;
        }
      }

      button{
        border-color: ${themeGet("colors.primary", "#009e7f")};
        background-color: ${themeGet("colors.primary", "#009e7f")};
      }

        &.normal button {
            border-color: ${themeGet("colors.primary", "#009e7f")} !important;
            background-color: ${themeGet("colors.primary", "#009e7f")} !important;
        }

        &.express button{
            border-color: #f01266 !important;
            background-color: #f01266 !important;
      }
      
      input {
        width: 70%;
        height: 50px;
        border-radius: 6px;
        font-family: ${themeGet("colors.fontFamily.0", "Lato, sans-serif")};
        border: 1px solid ${themeGet("colors.borderColor", "#e6e6e6")};
        color: ${themeGet("colors.darkBold", "#0D1136")};
        font-size: ${themeGet("fontSizes.2", "15")}px;
        font-weight: ${themeGet("fontWeights.3", "400")};
        line-height: 19px;
        padding: 0 18px;
        box-sizing: border-box;
        transition: border-color 0.25s ease;
        margin: 0px 10px;

        &:hover,
        &:focus {
          outline: 0;
        }

        &:focus {
          border-color: ${themeGet("colors.primary", "#009e7f")};
        }

        &::placeholder {
          color: ${themeGet("colorsdarkRegular", "#77798C")};
        }
      }

      &.express input:hover,
      &.express input:focus {
        outline: 0;
        border-color: #f01266;
      }
    }
  }

  .choose-payment-wrapper {
    width: 100%;
    
    .choose-payment-icon-wrapper {
      position: relative;
        display: -webkit-flex;
      display: flex;
      gap: 10px;
      background-color: #fff;
      padding: 10px 0;
      top: 25px;
      font-size: 18px;
        -webkit-align-items: center;
      align-items: center;
      width: 100%;
      color: #9cc54b;

        &.normal {
            color: #9cc54b !important;
        }

        &.express {
            color: #f01266 !important;
        }
      &:before {
        content: '';
        display: block;
        background-image: url(${paymentIcon});
        width: 32px;
        height: 32px;
      }

        &.express:before {
            background-image: url(${paymentExpressIcon}) !important;
        }
    }
    .choose-payment-container {
      padding: 5px;
      padding-top: 30px;

        .cod-payment-method {
            .payment-method-icon img {
                width: 120%;
                height: 120%;
            }
        }
    }
  }
  .wallet-pay-wrapper {
    width: 100%;
    padding-left: 15px;
    
    .wallet-icon-wrapper {
      position: relative;
        display: -webkit-flex;
      display: flex;
      gap: 10px;
      background-color: #fff;
      padding: 10px 0;
      top: 25px;
      left: -15px;
      font-size: 18px;
        -webkit-align-items: center;
      align-items: center;
      width: 100%;
      max-width: 270px;
      color: #9cc54b;

        &.normal {
            color: #9cc54b !important;
        }

        &.express {
            color: #f01266 !important;
        }
      &:before {
        content: '';
        display: block;
        background-image: url(${walletIcon});
        width: 32px;
        height: 32px;
      }

        &.express:before {
            background-image: url(${walletExpressIcon}) !important;
        }
    }
    .wallet-pay-btn {
      background-color: transparent;
      color: #000;
      border: 1px solid #e7e7e7;
      display: flex;
      flex-direction: row;
      align-items: center;
      line-height: 1.2em;
      padding: 15px 20px;
      
      &.btn-success:focus-visible,
      &.btn-success:active,
      &.btn-success:focus,
      &.btn-success { box-shadow: none; background-color: transparent; color: #000; border: 1px solid #e7e7e7; }
      
      .btn-title {
        flex: 2;
        text-align: left;
        
        .btn-sub-title {
          display: block;
          color: #999;
        }
      }
      
      input[type="checkbox"] {
        margin-right: 15px;
        accent-color: transparent !important;
        appearance: none;
        -webkit-appearance: none;
        width: 22px;
        height: 22px;
        border: 3px solid #ccc;
        border-radius: 4px;
        background-color: transparent;
        cursor: pointer;
        flex-shrink: 0;
        position: relative;
        transition: border-color 0.2s;

        &:checked {
          border-color: #9cc54b;
          border-width: 3px;
          background-color: transparent;

          &::after {
            content: '';
            position: absolute;
            left: 3px;
            top: -1px;
            width: 11px;
            height: 16px;
            border: 3px solid #9cc54b;
            border-top: none;
            border-left: none;
            transform: rotate(45deg);
          }
        }

        &:not(:checked) {
          border-color: #ccc;
          border-width: 3px;
          background-color: transparent;
        }
      }
    }
  }
  .btn-group-vertical { width: 100%; }

  @media (max-width: 767px) {
    padding: 20px;
    .btn-group-vertical {
      display: flex;
      align-items: center;
    }
  }

  input.selfdelivery {
    width: 17px;
    height: 17px;
  }

  &.paymentBox {
    .reusecore__button {
      @media (max-width: 600px) {
        padding-right: 0;
      }
    }
  }

  ${Heading} {
    :before {
      counter-increment: section-counter;
      content: counter(section-counter);
      font-family: "Lato", sans-serif;
      font-size: 16px;
      font-weight: ${themeGet("fontWeights.3", "400")};
      color: #ffffff;
      width: 35px;
      height: 35px;
        -webkit-border-radius: 50%;
      border-radius: 50%;
        display: -webkit-flex;
      display: flex;
        -webkit-align-items: center;
      align-items: center;
        -webkit-justify-content: center;
      justify-content: center;
      background-color: ${themeGet("colors.primary", "#9cc54b")};
      margin-right: 15px;
        -webkit-flex-shrink: 0;
      flex-shrink: 0;

      @media (max-width: 600px) {
        width: 30px;
        height: 30px;
        font-size: 14px;
      }
    }

      &.express:before {
          background-color: #f01266 !important;
      }

      &.normal:before {
          background-color: #9cc54b !important;
      }
  }
`;
export const OrderBox = styled.div`
  background-color: #ffffff;
  padding: 30px 20px 20px 20px;
  // padding-bottom: 20px;
  position: relative;
  // margin-bottom: 20px;
  box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.08);
`;
export const TotalProduct = styled.div`
  flex-grow: 1;
  text-align: right;
  padding-right: 60px;
`;

export const TotalPrice = styled.div`
  flex-grow: 1;
  text-align: left;
  padding-left: 60px;
`;

export const DeliverySchedule = styled.div`
  .radioGroup {
    justify-content: space-between;
    > label {
      margin-right: 0;
      flex: calc(33.3333333333% - 10px);
      max-width: calc(33.3333333333% - 10px);
      padding: 11px 15px;

      @media (max-width: 900px) and (min-width: 768px) {
        flex: calc(50% - 10px);
        max-width: calc(50% - 10px);
      }

      @media (max-width: 480px) {
        flex: 100%;
        max-width: 100%;
        margin-right: 0;
      }
    }
  }
  .form-control:focus {
    box-shadow: none !important;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  
  &.express textarea:hover,
  &.express textarea:focus {
    border-color: #f01266;
  }

  .radioGroup {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;

    label {
      margin-top: 0;
      width: calc(33.333333333% - 10px);
      max-width: calc(33.333333333% - 10px);
      margin-bottom: 15px;

      &:nth-child(3n) {
        margin-right: 0;
      }

      @media (max-width: 900px) and (min-width: 768px) {
        flex: calc(50% - 10px);
        max-width: calc(50% - 10px);

        &:nth-child(3n) {
          margin-right: 15px;
        }

        &:nth-child(2n) {
          margin-right: 0;
        }
      }

      @media (max-width: 480px) {
        flex: 100%;
        max-width: 100%;
        margin-right: 0;

        &:nth-child(3n) {
          margin-right: 0;
        }

        &:nth-child(2n) {
          margin-right: 0;
        }
      }
    }
  }

  .reusecore__button {
    width: auto;
    height: auto;
    display: flex;
    align-items: center;
    background-color: transparent;
    border: 0;
    outline: 0;
    border-radius: 0;
    padding: 0;
    font-family: "Lato", sans-serif;
    font-size: 14px;
    font-weight: ${themeGet("fontWeights.6", "700")};
    color: ${themeGet("colors.primary", "#9cc54b")};
    position: absolute;
    top: 40px;
    right: 30px;

    @media (max-width: 600px) {
      top: 27px;
      right: 20px;
    }
  }
`;

export const CheckoutSubmit = styled.div`
  margin-top: 25px;
  .reusecore__button {
    width: 100%;
  }
  @media (max-width: 425px) {
    padding: 0 40px;
  }
`;

export const InfoText = styled.span`
  font-family: "Lato", sans-serif;
  font-size: ${themeGet("fontSizes.2", "15")}px;
  font-weight: ${themeGet("fontWeights.3", "400")};
  color: ${themeGet("colors.darkBold", "#0D1136")};
  margin-bottom: 15px;
  margin-top: 15px;
`;

export const CouponBoxWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 5px 15px;

  .couponCodeText {
    margin-right: auto;
  }
`;

export const CouponCode = styled.p`
  font-family: "Lato", sans-serif;
  font-size: 14px;
  font-weight: ${themeGet("fontWeights.3", "400")};
  color: ${themeGet("colors.darkRegular", "#77798C")};
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: baseline;

  span {
    font-weight: ${themeGet("fontWeights.6", "700")};
    color: ${themeGet("colors.primary", "#9cc54b")};
    margin-left: 10px;
    
    &.express { color: #ff5b60 }
  }
`;

export const RemoveCoupon = styled.div`
  font-family: "Lato", sans-serif;
  font-size: 12px;
  font-weight: ${themeGet("fontWeights.3", "400")};
  color: ${themeGet("colors.secondary", "#ff5b60")};
  width: auto;
  height: auto;
  display: inline-block;
  border: 0;
  outline: 0;
  box-shadow: none;
  background-color: transparent !important;
  padding: 0;
  cursor: pointer;
  margin-left: 5px;
`;

export const CouponInputBox = styled.div`
  width: 100%;
  display: flex;
  align-items: center;

  @media (max-width: 600px) {
    .reusecore__button {
      padding-right: 30px !important;
      flex-shrink: 0;
    }
  }
`;

export const Input = styled(Inputs)`
  width: 50%;
  margin-right: 20px;
  input {
    border: 1px solid ${themeGet("colors.lightDarkColor", "#e6e6e6")} !important;
    background-color: ${themeGet("colors.lightColor", "#f7f7f7")};
  }

  @media (max-width: 600px) {
    width: 100%;
  }
`;

export const HaveCoupon = styled.div`
  font-family: "Lato", sans-serif;
  font-size: ${themeGet("fontSizes.2", "15")}px;
  font-weight: ${themeGet("fontWeights.3", "400")};
  color: ${themeGet("colors.primary", "#9cc54b")};
  width: auto;
  height: auto;
  display: inline-block;
  border: 0;
  outline: 0;
  box-shadow: none;
  background-color: transparent !important;
  padding: 0;
  cursor: pointer;
  margin-top: 10px;
  
  &.express { color: #f01266; }
`;

export const ErrorMsg = styled("span")`
  font-family: "Lato", sans-serif;
  font-size: 12px;
  font-weight: ${themeGet("fontWeights.3", "400")};
  color: ${themeGet("colors.secondaryHover", "#FF282F")};
  padding-top: 10px;
  display: flex;
  margin-left: 20px;
`;

export const TermConditionText = styled.span`
  font-family: "Lato", sans-serif;
  font-size: 13px;
  font-weight: ${themeGet("fontWeights.3", "400")};
  color: ${themeGet("colors.darkRegular", "#77798C")};
  line-height: 1.5;
  margin-top: 30px;
  display: block;
`;

export const TermConditionLink = styled.span`
  font-family: "Lato", sans-serif;
  font-size: 13px;
  font-weight: ${themeGet("fontWeights.3", "400")};
  color: ${themeGet("colors.secondary", "#ff5b60")};
  margin-left: 5px;
  cursor: pointer;
  line-height: 1.5;
`;

export const CartWrapper = styled.div`
  width: 60%;
  flex-shrink: 0;
  direction: ltr;
  padding: 20px;

  // @media (min-width: 768px) and (max-width: 1200px) {
  //   width: 500px;
  // }

  @media (max-width: 767px) {
    width: 100%;
    padding-left: 15px;
    padding-right: 15px;
  }
  @media (max-width: 425px) {
    padding-left: 0;
    padding-right: 0;
  }
`;

export const OrderInfo = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  // @media (min-width: 768px) and (max-width: 990px) {
  //   padding-right: 15px;
  // }
`;

export const Title = styled.h3`
  font-family: "Lato", sans-serif;
  font-size: 28px;
  font-weight: bolder;
  color: ${themeGet("colors.darkBold", "#0D1136")};
  padding-left: 20px;

  @media (min-width: 990px) {
    width: 90%;
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
  }
  @media (max-width: 425px){
    font-size: 1.7rem;
    font-weight: 600;
  }
`;

export const ItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 8px;
  // padding-left: 15px;
`;

export const CouponListWrapper = styled.div`
  /* margin-top: 25px; */
  padding: 10px;
  .apply_button{
    display: flex;
    align-items: center;
    justify-content: end;
  }
`;

export const CouponCodeItem = styled.div`
  width: 100%;
  padding: 10px;
  color: #676767FF;
  .title {
    font-size: 14px;
    /* margin-left: 32px; */
  }
  label {
    margin-bottom: 0;
  }
  .MuiTypography-body1 {
    width: 100% !important;
  }
`;

export const CalculationWrapper = styled.div`
  border-top: 1px solid ${themeGet("colors.lightDarkColor", "#e6e6e6")};
  padding: 20px;
  margin-top: 20px;
  width: 100%;
  box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.08);
  background-color: #fff;
  .sub-container {
    width: 60%;
    margin-left: auto;
  }

  @media (max-width: 767px) {
    .sub-container {
      width: 100%;
    }
  }
`;

export const ProvinceDeliveryDetails = styled.div`
  border-top: 1px solid ${themeGet("colors.lightDarkColor", "#e6e6e6")};
  padding: 20px;
  margin-top: 20px;
  width: 100%;
  box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.08);
  background-color: #fff;

  .title {
    margin-bottom: 10px;
    font-size: 21px;
    font-weight: 500;
  }
`;

export const Items = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  margin-bottom: 25px;
  .item-info{
    flex: 1;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    &>* {
        flex: 1 1;
      }
  }
  

  &:last-child {
    margin-bottom: 0;
  }
`;

export const IsSameDay = styled.div`
padding-bottom: 10px;
.ribbon {
  text-transform: uppercase;
  color: white;
}
.ribbon3 {
  text-transform: uppercase;
  color: white;
  font-size: 11px;
  width: 120px;
  height: 23px;
  line-height: 23px;
  padding: 5px;
  // position: absolute;
  // left: 0px;
  // top: -20px;
  background: #9cc54b;
}
`;

export const EditItem = styled.button({
  padding: "5px",
  border: 0,
  outline: 0,
  marginLeft: "15px",
  cursor: "pointer",
  color: "#9cc54b",
  transition: "all 0.4s ease",
	WebkitTransition: "all 0.4s ease",
  borderRadius: "50%",
	WebkitBorderRadius: "50%",
  lineHeight: "7px",
  backgroundColor: "transparent",
  // backgroundColor: "#9cc54b",

	"&.normal": {
		color: "#9cc54b !important",
	},
	"&.normal:hover": {
		color: "#9cc54b !important",
	},
  "&.express": {
	  color: "#f01266 !important",
  },
  "&.express:hover": {
	  color: "#ff5b60 !important",
  },
  "&:hover": {
    color: "#9cc54b",
  },
});

export const Quantity = styled.span`
  font-family: "Lato", sans-serif;
  font-size: 14px;
  font-weight: ${themeGet("fontWeights.6", "700")};
  color: ${themeGet("colors.darkBold", "#0D1136")};
`;

export const Multiplier = styled.span`
  font-family: "Lato", sans-serif;
  font-size: 14px;
  font-weight: ${themeGet("fontWeights.3", "400")};
  color: ${themeGet("colors.darkRegular", "#77798C")};
  margin: 0 12px;
`;
export const ItemImageContainer = styled.span`
  width: 70px;
  height: 70px;
  min-width: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 5px;

  img {
    width: auto;
    max-height: 70px;
    max-width: 70px;
  }

`
export const ItemInfoWrapper =styled.div`
  min-width: 150px;
  .product_name {
    overflow:hidden;
    white-space: pre-wrap;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
`;
export const ItemInfo = styled.span`
  font-family: "Lato", sans-serif;
  font-size: 14px;
  font-weight: ${themeGet("fontWeights.3", "400")};
  color: ${themeGet("colors.darkRegular", "#77798C")};
  margin-right: 15px;
`;

export const Price = styled.span`
  font-family: "Lato", sans-serif;
  font-size: 18px;
  font-weight: ${themeGet("fontWeights.9", "900")};
  color: #9cc54b;
  text-align: end;
  width: 100px;

  &.riel {
    font-size: 14px;
    font-weight: ${themeGet("fontWeights.3", "400")};
    color: ${themeGet("colors.darkBold", "#0D1136")};
  }

  &.total-price {
    width: auto;
  }

    &.normal {
        color: #9cc54b !important;
    }
  &.express {
      color: #f01266 !important;
  }

  @media (max-width: 425px){
    h3{
      font-size: 26px;
        font-weight: 600;
    }
  }

`;

export const PriceEach = styled.span`
  font-size: 14px;
  width: 100px;

  .original-price {
    color: red;
    text-decoration-line: line-through;
  }
  @media (max-width: 425px) {
    display: none;
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 10px;
`;

export const Text = styled.span`
  font-family: "Lato", sans-serif;
  font-size: 20px;
  font-weight: ${themeGet("fontWeights.3", "400")};
  // color: ${themeGet("colors.darkRegular", "#77798C")};
  color: #212529;
`;

export const Bold = styled.span`
  font-family: "Lato", sans-serif;
  font-size: 14px;
  font-weight: ${themeGet("fontWeights.6", "700")};
  color: ${themeGet("colors.darkBold", "#0D1136")};

  @media (max-width: 425px){
    h3{
      font-size: 26px;
      font-weight: 600;      
    }
  }
`;

export const Small = styled.span`
  font-family: "Lato", sans-serif;
  font-size: 11px;
`;

export const NoProductMsg = styled.h3`
  font-family: "Lato", sans-serif;
  font-size: 14px;
  font-weight: ${themeGet("fontWeights.3", "400")};
  color: ${themeGet("colors.darkRegular", "#77798C")};
  line-height: 1.2;
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 25px;
  align-items: center;
`;

export const PayWithWallet = styled.div`
  width: 100%;
  
  label.btn-success {
    background-color: transparent;
    color: #000;
    font-weight: bold;
    border: 1px solid #e7e7e7;
    
    &:focus,
    &.focus,
    &.active:focus { box-shadow: none !important; }
    
    &:hover,
    &.active {
      background-color: transparent !important;
      color: #000 !important;
      border-color: #9cc54b !important;
    }
    
    input {
      margin-right: 25px;
      accent-color: #9cc54b !important;
    }
  }
  
  @media (max-width: 767px) {
    label.case-on-delivery { height: 60px; } 
  }
`;
export const PaymentOnlineWrapper = styled.div`
  width: 100%;
 .toggle {
    width: 100%;
    background: inherit;
    border: none;
    padding: 0;
 }
`;
export const CaseOnDeliveryBtn = styled.div`
  width: 100%;

  label.case-on-delivery {
    width: 100%;
      display: -webkit-flex;
    display: flex;
    background-color: transparent !important;
    font-weight: 600;
    color: #000;
    text-align: left;
    margin-bottom: 0;
    border-width: 0.15em;
    border-color: transparent;
    height: 74px;
      -webkit-align-items: center;
    align-items: center;

      &.normal {
          background-color: #fff;
          color: #000;

          &.active,
          &:hover {
              border-color: #9cc54b !important;
          }

          input {
              accent-color: #9cc54b !important;
          }
      }

      &.express {
      background-color: #fff;
      color: #000;

      &.active,
      &:hover {
          border-color: #f01266 !important;
      }
      input {
        accent-color: #f01266 !important;
      }
    }

    &:focus,
    &.focus,
    &.active:focus { box-shadow: none !important; }

    &.active {
      background-color: transparent !important;
      color: #000 !important;
      border-color: #9cc54b !important;
    }

    input {
      margin-right: 25px;
      accent-color: #9cc54b !important;
    }
  }

  @media (max-width: 767px) {
      label.case-on-delivery {
          height: 60px;
      }
  }
`;
export const PaymentOnlineBtn = styled.div`
  width: 100%;

  label.case-on-delivery {
    width: 100%;
      display: -webkit-flex;
    display: flex;
    background-color: transparent !important;
    font-weight: 600;
    color: #000;
    text-align: left;
    margin-bottom: 0;
    border-width: 0.15em;
    border-color: transparent;
    height: 74px;
      -webkit-align-items: center;
    align-items: center;

      &.normal {
          background-color: #fff;
          color: #000;

          &.active,
          &:hover {
              border-color: #9cc54b !important;
          }

          input {
              accent-color: #9cc54b !important;
          }
      }

      &.express {
      background-color: #fff;
      color: #000;

      &.active,
      &:hover {
          border-color: #f01266 !important;
      }
      input {
        accent-color: #f01266 !important;
      }
    }

    &:focus,
    &.focus,
    &.active:focus { box-shadow: none !important; }

    &.active {
      background-color: transparent !important;
      color: #000 !important;
      border-color: #9cc54b !important;
    }

    input {
      margin-right: 25px;
      accent-color: #9cc54b !important;
    }
  }

  @media (max-width: 767px) {
      label.case-on-delivery {
          height: 60px;
      }
  }
`;
export const PaymentMethodWrapper = styled.div`
    -webkit-flex-direction: column;
  flex-direction: column;
  width: 100%;
  margin: 0 -10px;
    -webkit-align-items: start;
  align-items: start;
  margin: 0 auto;
  border-top: 1px solid #e7e7e7;
  margin-top: 5px;

    & > label {
    background-color: transparent !important;
    padding: 0;
    margin: 5px 0;
        display: -webkit-flex;
    display: flex;
    border: none;
    gap: 10px;
        -webkit-flex-direction: row;
    flex-direction: row;
        -webkit-align-items: center;
    align-items: center;
    padding: 0 15px;
    border: 0.15em solid transparent !important;

        &.btn-info:not(:disabled):not(.disabled).active,
    &.btn-info:not(:disabled):not(.disabled):active,
    &.show>.btn-info.dropdown-toggle,
    // &:hover,
    &.card.active,
        &.abapay.active,
        &.normal.active {
      background-color: transparent !important;
      border: 0.15em solid #9cc54b !important;
    }

        &.express.active,
    &.express.active:not(:disabled):not(.disabled):active,
    // &.express:hover,

        &.express.btn-info:not(:disabled):not(.disabled).active,
    &.express.btn-info:not(:disabled):not(.disabled):active,
    &.express.show>.btn-info.dropdown-toggle,
    &.express.card.active,
    &.express.abapay.active {
      border-color: #f01266 !important;

            input {
                accent-color: #f01266 !important;
            }
    }

        input { accent-color: #9cc54b; }

        input.normal {
            accent-color: #9cc54b !important;
        }

        input.express {
            accent-color: #f01266 !important;
        }

        &:focus,
        input {
            accent-color: #f01266 !important;
        }
    }

    input {
        accent-color: #9cc54b;
    }

    input.normal {
        accent-color: #9cc54b !important;
    }

    input.express {
            accent-color: #f01266 !important;
        }

        &:focus,
    &.btn-info.focus,
    &.active:focus { box-shadow: none !important; }

        img { display: block; width: auto; height: 50px; margin: 10px; }

        .info {
      color: #000;
      font-size: 16px;
      font-weight: bold;
      text-align: left;
      line-height: 1em;

            img { display: block; width: auto; height: 20px; margin: 0; margin-top: 5px; }
      .subtitle { display: block; font-size: 14px; font-weight: normal; color: grey; margin-top: 5px; }
    }

    @media (max-width: 767px) {
        label img {
            height: 35px;
        }
  }
`;

export const DeliveryOptionsWrapper = styled.div`
  box-sizing: border-box;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 0.5rem;

  .btn-delivery-option {
    width: 100%;
    min-height: 50px;
    height: auto;
    padding: 5px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background: #e7e7e7 !important;
    color: #0D1136;
    border: 1px solid #e7e7e7 !important;
    box-shadow: none;
    transition: all 0.3s ease;

    input{
      display: block;
      margin-left: 5px;
      margin-right: 10px;
      height: 0.85rem;
      width: 0.85rem;
      flex-shrink: 0;
    }
    
    span {
      font-size: 0.875rem;
      font-weight: 500;
      text-align: start;
      line-height: 1.25;
    }

    &.active {
      background: #9cc54b !important;
      color: #fff;
      border-color: #9cc54b;
    }

    @media (max-width: 450px){
      span {
        font-size: 13px;
        line-height: 1.3;
      }
    }
  }
`;

export const OosOptionsWrapper = styled.div`
  box-sizing: border-box;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 0.5rem;

  .btn-oos-option {
    width: 100%;
    min-height: 50px;
    height: auto;
    padding: 5px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background: #e7e7e7 !important;
    color: #0D1136;
    border: 1px solid #e7e7e7 !important;
    box-shadow: none;
    transition: all 0.3s ease;
 
    input {
      display: block;
      margin-left: 5px;
      margin-right: 10px;
      height: 0.85rem;
      width: 0.85rem;
      flex-shrink: 0;
    }
    
    .content {
      display: flex;
      flex-direction: column;
      align-items: start;

      .title {
        font-size: 1rem;
        font-weight: 500;
      }
      .desc {
        font-size: 0.825rem;
        text-align: start;
      }
    }

    &.active {
      background: #9cc54b !important;
        border-color: #9cc54b !important;
        color: #fff;
    }

      &.active.normal {
          background: #9cc54b !important;
          border-color: #9cc54b !important;
      color: #fff;
      }

      &.active.express {
          background: #f01266 !important;
          border-color: #f01266 !important;
          color: #fff;
    }

    @media (max-width: 450px){
      span {
        font-size: 13px;
        line-height: 1.3;
      }
    }
  }
`;

export const HistoryCardsWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 0.25rem;
  // padding: 0.5rem;

  .toggle-btn {
    width: 100%;
    border: none !important;
    background: rgba(0, 0, 0, 0.025) !important;
    display: flex;
    align-items: center;
    gap: 1rem;
    box-shadow: none !important;
    outline: none !important;
    border: none !important;

    &:hover {
      background: rgba(0, 0, 0, 0.075) !important;
    }

    &:focus,
    &:active {
      box-shadow: none !important;
      outline: none !important;
      border: none !important;
    }
    
    input {
      display: block;
      margin-left: 0.5rem;
      accent-color: #9cc54b !important;
      width: 2rem;
      height: 2rem;
    }


    img {
      display: block;
      height: auto;
      width: 7.5rem;
      object-fit: contain;
    }

    .card-content {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      color: #1e2e27;

      .expiry-content {
        display: flex;
        align-items: center;
        gap: 0.25rem;
      }
    }

    &.express {
      input {
        accent-color: #f01266 !important;
      }
    }

    @media only screen and (max-width: 520px){
      gap: 0.5rem;
      
      img {
        width: 6rem;
      }

      input {
        margin-left: 0.25rem;
      }

      .card-number {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
      }
    }
  }
`;

export const SelectedCouponBtn = styled.div`
  flex-direction: column;
  width: 100%;
  margin: 0 -10px;
  align-items: start;
  margin: 0 auto;
  margin-bottom: 10px;
  
  label {
    background-color: transparent;
    padding: 0;
    height: 75px;
    margin: 5px 0;
    display: flex;
    border: none;
    gap: 10px;
    flex-direction: row;
    align-items: center;
    padding: 0 15px;
    border: 0.15em solid transparent !important;

    &.btn-info:not(:disabled):not(.disabled).active,
    &.btn-info:not(:disabled):not(.disabled):active,
    &.show>.btn-info.dropdown-toggle,
    &:hover,
    &.card.active,
    &.selected-coupon.active {
      background-color: transparent !important;
      border: 0.15em solid #9cc54b !important;
    }
    
    &.express.active,
    &.express.active:not(:disabled):not(.disabled):active,
    &.express:hover,
     
    &.express.btn-info:not(:disabled):not(.disabled).active,
    &.express.btn-info:not(:disabled):not(.disabled):active,
    &.express.show>.btn-info.dropdown-toggle,
    &.express.card.active,
    &.express.abapay.active {
      border-color: #f01266 !important;
      
      input { accent-color: #f01266; }
    }
    
    input { accent-color: #9cc54b; }
    input.express { accent-color: #f01266; }
    
    &:focus,
    &.btn-info.focus,
    &.active:focus { box-shadow: none !important; }
    
    img { display: block; width: auto; height: 50px; margin: 10px; }
    
    .info {
      color: #000;
      font-size: 16px;
      font-weight: bold;
      text-align: left;
      line-height: 1em;
      
      img { display: block; width: auto; height: 20px; margin: 0; margin-top: 5px; }
      .subtitle { display: block; font-size: 14px; font-weight: normal; color: grey; margin-top: 5px; }
    }
  }
  
  @media (max-width: 767px) {
    label img { height: 35px; } 
  }
`;

export default CheckoutWrapper;

export const ButtonApply = styled("button")`
  /* button default style */
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: ${themeGet("heights.3", "48")}px;
  width: 25%;
  border-radius: 6px;
  font-family: 'Lato', sans-serif;
  font-size: ${themeGet("fontSizes.2", "15")}px;
  font-weight: ${themeGet("fontWeights.6", "700")};
  text-decoration: none;
  // padding-top: 0;
  // padding-bottom: 0;
  // padding-left: ${themeGet("space.7", "30")}px;
  // padding-right: ${themeGet("space.7", "30")}px;
  border: 0;
  transition: all 0.3s ease;
  box-sizing: border-box;
  color: #FFFFFF;
  margin: 0px 10px;
  min-width: 90px;
  padding: 0;

  span.btn-text {
    padding-left: ${themeGet("space.1", "4")}px;
    padding-right: ${themeGet("space.1", "4")}px;
    white-space: nowrap;
  }
  span.btn-icon {
    display: flex;
    > div {
      display: flex !important;
    }
  }

  &:focus {
    outline: none;
  }

  &.disabled{
    color: ${themeGet("colors.labelColor", "#767676")};
    background-color: ${themeGet("colors.borderColor", "#E6E6E6")};
    border-color: ${themeGet("colors.borderColor", "#E6E6E6")};

    &:hover{
      color: ${themeGet("colors.labelColor", "#767676")};
      background-color: ${themeGet("colors.borderColor", "#E6E6E6")};
      border-color: ${themeGet("colors.borderColor", "#E6E6E6")};
    }
  }

  /* Material style goes here */
  &.is-material {
    box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12);
  }

  /* When button on loading stage */
  &.is-loading {
    .btn-text {
      padding-left: ${themeGet("space.2", "8")}px;
      padding-right: ${themeGet("space.2", "8")}px;
    }
  }
`;

export const ButtonRemove = styled("button")`
  /* button default style */
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: ${themeGet("heights.3", "48")}px;
  width: 25%;
  border-radius: 6px;
  font-family: 'Lato', sans-serif;
  font-size: ${themeGet("fontSizes.2", "15")}px;
  font-weight: ${themeGet("fontWeights.6", "700")};
  text-decoration: none;
  padding-top: 0;
  padding-bottom: 0;
  padding-left: ${themeGet("space.7", "30")}px;
  padding-right: ${themeGet("space.7", "30")}px;
  border: 0;
  transition: all 0.3s ease;
  box-sizing: border-box;
  color: #FFFFFF;
  margin: 0px 10px;
  background-color: #e1232e !important;

  span.btn-text {
    padding-left: ${themeGet("space.1", "4")}px;
    padding-right: ${themeGet("space.1", "4")}px;
    white-space: nowrap;
  }
  span.btn-icon {
    display: flex;
    > div {
      display: flex !important;
    }
  }

  &:focus {
    outline: none;
  }

  &.disabled{
    color: ${themeGet("colors.labelColor", "#767676")};
    background-color: ${themeGet("colors.borderColor", "#E6E6E6")};
    border-color: ${themeGet("colors.borderColor", "#E6E6E6")};

    &:hover{
      color: ${themeGet("colors.labelColor", "#767676")};
      background-color: ${themeGet("colors.borderColor", "#E6E6E6")};
      border-color: ${themeGet("colors.borderColor", "#E6E6E6")};
    }
  }

  /* Material style goes here */
  &.is-material {
    box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12);
  }

  /* When button on loading stage */
  &.is-loading {
    .btn-text {
      padding-left: ${themeGet("space.2", "8")}px;
      padding-right: ${themeGet("space.2", "8")}px;
    }
  }
`;



export const CounterBox = styled.div(
  css({
    display: "flex",
    backgroundColor: "transparent",
    color: "#000",
    fontSize: 2,
    fontWeight: 6,
  }),
  {
    gap: '8px',
    justifyContent: "space-between",
    alignItems: "center",
    flexShrink: 0,
    "&:focus": {
      outline: "none",
    },
    "&.express button .spinner-border": {
      color: '#f01266',
    },
  },
  variant({
    variants: {
      horizontal: {
        width: 'auto',
        height: [25,36],
      },
      vertical: {
        width: 40,
        height: 100,
        flexDirection: "column-reverse",
      },
      lightHorizontal: {
        width: 'auto',
        height: 36,
        backgroundColor: "lightColor",
        color: "darkBold",
      },

      lightVertical: {
        width: 40,
        height: 100,
        flexDirection: "column-reverse",
        backgroundColor: "lightColor",
        color: "darkBold",
      },
    },
  })
);

export const CounterButton = styled.button(
  {
    border: "1px solid #E6E6E6",
    backgroundColor: "#fff",
    color: "#6c757d",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    "&:hover, &:focus": {
      outline: "none",
    },
    ".spinner-border": {
      width: '0.7rem',
      height: '0.7rem',
    },
    '&.circle': {
      width: 30,
      height: 30,
      borderRadius: '50%',
      padding: 0,
    },
    '&.minus': {
      backgroundColor: '#fff',
      borderColor: '#E6E6E6',
      color: '#9cc54b',
      '&:hover': {
        backgroundColor: '#fce4ec',
        borderColor: '#dc3545',
        color: '#dc3545',
      },
    },
    '&.plus': {
      backgroundColor: '#9cc54b',
      borderColor: '#9cc54b',
      color: '#fff',
      '&:hover': {
        backgroundColor: '#8ab743',
        borderColor: '#8ab743',
        color: '#fff',
      },
    },
    "@media screen and (max-width: 500px )": {
      width: 26,
      height: 26,
    },
  },
  variant({
    variants: {
      lightHorizontal: {
        color: "darkRegular",
      },
      lightVertical: {
        color: "darkRegular",
      },
    },
  })
);

export const DeleteButton = styled.button(
  {
    border: "none",
    backgroundColor: "transparent",
    color: "#767676",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 6,
    cursor: "pointer",
    // borderRadius: "100%",
    marginLeft: 10,
    // "border": "1px solid",
    "&:hover, &:focus": {
      outline: "none",
      opacity: 0.7
    },
    "@media screen and (max-width: 500px )": {
      padding: 4,
    },
  }
);

export const CounterValue = styled.input({
  // pointerEvents: "none",
  width: "30px",
  border: "none",
  textAlign: "center",
  padding: 0
});
export const ScrollBarsWrapper = styled.div({
  background: "#fff",
    "&>div>div": {
      'overflow-y': 'hidden !important',
      'marginLeft': '0 !important',
      'marginBottom': '0 !important',
     "-ms-overflow-style": "none",
      "scrollbar-width": "none",
    },
    "&>div>div::-webkit-scrollbar": {
      "display": "none"
    }
  // "@media (max-width: 768px)": {
  //   "&>div": {
  //     maxHeight: '400px',
  //     "&>div": {
  //       maxHeight: '400px',
  //       overflow: 'scroll'
  //     }
  //   },
  // },
  // '@media (min-width: 768px)': {
  //   "&>div>div": {
  //     'overflow-y': 'hidden !important',
  //     'marginLeft': '0 !important',
  //     'marginBottom': '0 !important',
  //    "-ms-overflow-style": "none",
  //     "scrollbar-width": "none",
  //   },
  //   "&>div>div::-webkit-scrollbar": {
  //     "display": "none"
  //   }
  // }
  
})

CounterValue.displayName = "CounterValue";
CounterButton.displayName = "CounterButton";
CounterBox.displayName = "CounterBox";
CounterBox.defaultProps = {
  variant: "horizontal",
};
